import {
  GET_ALL_AFFILIATES,
  GET_AFFILIATE
} from 'src/store/mutation-types'

export default {
  [GET_ALL_AFFILIATES] (state, affiliates) {
    state.affiliates = affiliates
  },
  [GET_AFFILIATE] (state, affiliate) {
    state.affiliate = affiliate
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliate/store/mutations.js